// modal/leger.js
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
// import { APILA } from "../../../../../config/apila";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Button } from "reactstrap";
import axios from "axios";
import { ClipLoader} from "react-spinners";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import { FiTrash2 } from "react-icons/fi";

/* ===========================
   🔥 STYLE
=========================== */
const css = `
    /* ===== POPUP PILIH NILAI ===== */
    .ysb-score-popover{
      position: fixed;
      z-index: 9999;
      background: #fff;
      border: 1px solid #dbe6ff;
      border-radius: 10px;
      box-shadow: 0 8px 24px rgba(0,0,0,.12);
      padding: 8px;
      min-width: 170px;
    }
    .ysb-score-popover-grid{
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 6px;
    }
    .ysb-score-btn{
      border: 1px solid #cddcff;
      background: #f6f9ff;
      border-radius: 8px;
      height: 34px;
      font-weight: 700;
      cursor: pointer;
    }
    .ysb-score-btn:hover{
      background: #e8f0ff;
    }
    .ysb-score-btn:disabled{
      cursor: not-allowed;
      opacity: .5;
    }

    .ysb-score-btn-danger{
      border-color: #ffd5d5;
      background: #fff5f5;
    }
    .ysb-score-btn-danger:hover{
      background: #ffeaea;
    }

    .ysb-score-popover-grid-inline{
      display: grid;
      grid-template-columns: repeat(5, 1fr); /* 1 2 3 4 + trash */
      gap: 6px;
    }

    .ysb-score-btn-trash{
      border-color: #ffd5d5;
      background: #fff5f5;
      font-size: 16px;
      line-height: 1;
    }
    .ysb-score-btn-trash:hover{
      background: #ffeaea;
    }

`;

export default function ModalLeger({ show, onHide, data_leger, onSaved }) {
  const [rows, setRows] = useState([]);
  const [savingMap, setSavingMap] = useState({});

  // selalu pegang state rows terbaru agar save tidak baca state lama
  const rowsRef = useRef([]);
    useEffect(() => {
      rowsRef.current = rows;
  }, [rows]);

  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("id_admin")?.replace(/[|&;$%@"<>()+,]/g, "");

  const savingKey = (rowIndex, group) => `${group}__${rowIndex}`;

  const getValue = (row, key) => {
    if (!row || !row[key]) return {};
    return row[key]; // object
  };

  // =========================
  // VALIDASI INPUT CAPAIAN (hanya 1 s/d 4)
  // =========================
  const CAPAIAN_MIN = 1;
  const CAPAIAN_MAX = 4;

  const normalizeCapaianString = (v) => (v ?? "").toString().replace(",", ".").trim();


  // untuk controlled input: izinkan state sementara seperti "" saja
  const sanitizeCapaianInput = (next, prev = "") => {
    const s = normalizeCapaianString(next);

    if (s === "") return "";

    // ❌ blok desimal (titik/koma)
    if (s.includes(".") || s.includes(",")) return prev;

    // hanya 1 digit angka
    if (!/^\d$/.test(s)) return prev;

    const num = Number(s);
    if (!Number.isFinite(num)) return prev;

    // range wajib 1 - 4
    if (num < CAPAIAN_MIN || num > CAPAIAN_MAX) return prev;

    return s;
  };


  const validateCapaianRange = (val) => {
    const s = normalizeCapaianString(val);

    // kosong = dianggap belum input (boleh)
    if (s === "") return { ok: true, num: null, s };

    // ❌ kalau ada desimal, anggap tidak valid
    if (s.includes(".") || s.includes(",")) return { ok: false, num: null, s };

    // harus 1 digit angka
    if (!/^\d$/.test(s)) return { ok: false, num: null, s };

    const num = Number(s);
    if (!Number.isFinite(num)) return { ok: false, num: null, s };

    if (num < CAPAIAN_MIN || num > CAPAIAN_MAX) return { ok: false, num, s };

    return { ok: true, num, s };
  };

  // konversi "25" atau "25%" menjadi 0.25
  const parsePercentage = (val) => {
    if (val === null || val === undefined || val === "") return 0;
    const cleaned = val.toString().replace("%", "").trim();
    const num = parseFloat(cleaned);
    if (isNaN(num)) return 0;
    return num / 100;
  };

  // hitung capaian x bobot → 2 angka di belakang koma
  const calculateScore = (capaian, bobot) => {
    const c = parseFloat(capaian ?? 0);
    const b = parsePercentage(bobot);
    if (!c || !b) return 0;
    return parseFloat((c * b).toFixed(2));
  };

  // ambil nilai yang akan ditampilkan:
  // 1. kalau field .nilai sudah terisi dan numerik → pakai itu
  // 2. kalau kosong → hitung dari capaian x bobot
  const getScore = (item) => {
    if (!item) return 0;

    if (item.nilai !== undefined && item.nilai !== null && item.nilai !== "") {
      const n = parseFloat(item.nilai);
      if (!isNaN(n)) return n;
    }

    return calculateScore(item.capaian, item.bobot);
  };

  const formatScore = (num) => {
    if (num === null || num === undefined || num === "") return "";
    const n = Number(num);
    if (!Number.isFinite(n)) return "";
    if (Number.isInteger(n)) return n.toString();
    return n.toFixed(2);
  };

  // hitung nilai akhir per baris (jumlah semua nilai)
  const calculateFinal = (row) => {
    const kepsek = getValue(row, "nilai_kepala_sekolah");
    const guru = getValue(row, "nilai_guru");
    const muridPeer = getValue(row, "nilai_murid_peer_assessment");
    const muridSelf = getValue(row, "nilai_murid_self_assessment");
    const otm = getValue(row, "nilai_orang_tua_murid");
    const karyawan = getValue(row, "nilai_karyawan");

    const total =
      getScore(kepsek) +
      getScore(guru) +
      getScore(muridPeer) +
      getScore(muridSelf) +
      getScore(karyawan) +
      getScore(otm);

    return formatScore(total);
  };

  const getKKCA = (nilaiAkhir) => {
    const n = Number(nilaiAkhir);
    if (!Number.isFinite(n)) return "Adab Mulai Terpuji";

    if (n >= 1 && n <= 2.49) return "Adab Mulai Terpuji";
    if (n >= 2.5 && n <= 2.99) return "Adab Cukup Terpuji";
    if (n >= 3.0 && n <= 3.49) return "Adab Terpuji";
    if (n >= 3.5 && n <= 4.0) return "Adab Sangat Terpuji";

    return "";
  };

  // =========================
  // ✅ Hitung average untuk table leger (di halaman utama)
  // Kita ambil rata-rata dari nilai_akhir tiap indikator (sub element).
  // =========================
  const calculateRecapAverage = (rowsInput = []) => {
    const arr = Array.isArray(rowsInput) ? rowsInput : [];
    let total = 0;
    let count = 0;

    for (const r of arr) {
      const s = calculateFinal(r); // string (formatted)
      const n = Number(s);
      if (Number.isFinite(n)) {
        total += n;
        count += 1;
      }
    }

    if (!count) return "";
    const avg = total / count;
    // format mirip tampilan lainnya
    return Number.isInteger(avg) ? avg.toString() : avg.toFixed(2);
  };

  const emitSavedToParent = (nextRows) => {
    if (typeof onSaved !== "function") return;

    const average = calculateRecapAverage(nextRows);
    const kkca_description = getKKCA(average);

    onSaved({
      ysb_element_recap_id: data_leger?.ysb_element_recap_id,
      ysb_student_id: data_leger?.ysb_student_id,
      ysb_element_id: data_leger?.ysb_element_id,
      average,
      kkca_description,
      sub_elements: nextRows,
    });
  };


  // setiap kali data_leger berubah, isi ulang baris
  useEffect(() => {
    const withLastSaved = (obj) => {
      const o = obj ? { ...obj } : {};
      // prevent save berulang (blur tanpa perubahan)
      o.__lastSavedCapaian = o.capaian ?? "";
      return o;
    };

    const nextRows = (data_leger?.sub_elements || []).map((r) => {
      // clone semua group yang dipakai di tabel (biar semuanya “hidup” & konsisten)
      const muridPeer = withLastSaved(r?.nilai_murid_peer_assessment);
      const muridSelf = withLastSaved(r?.nilai_murid_self_assessment);
      const otm = withLastSaved(r?.nilai_orang_tua_murid);
      const nk = withLastSaved(r?.nilai_karyawan);

      const baseRow = {
        ...r,
        nilai_murid_peer_assessment: muridPeer,
        nilai_murid_self_assessment: muridSelf,
        nilai_orang_tua_murid: otm,
        nilai_karyawan: nk,
      };

      const finalScore = baseRow.nilai_akhir ?? calculateFinal(baseRow);

      return {
        ...baseRow,
        // nilai akhir langsung siap tampil (dan akan auto berubah saat input)
        nilai_akhir: finalScore,
        // biar KKCA juga langsung kebaca dari awal (kamu tampilkan row.kkca_description)
        kkca_description: baseRow.kkca_description ?? getKKCA(finalScore),
      };
    });

    setRows(nextRows);
  }, [data_leger]); // eslint-disable-line react-hooks/exhaustive-deps


  // input yang bisa di-edit (karyawan) → auto hitung nilai-nya & nilai akhir realtime
  const handleChangeInput = (index, group, field, value) => {
    setRows((prev) => {
      const copy = [...(prev || [])];
      const target = { ...(copy[index] || {}) };

      const groupObj = { ...(target[group] || {}) };

      // ✅ batasi input capaian hanya 1 - 4
      const prevVal = (groupObj[field] ?? "").toString();
      const nextVal = field === "capaian" ? sanitizeCapaianInput(value, prevVal) : value;
      groupObj[field] = nextVal;

      // auto hitung nilai (capaian x bobot)
      const { capaian, bobot } = groupObj;
      groupObj.nilai = calculateScore(capaian, bobot);

      target[group] = groupObj;

      // ✅ nilai akhir otomatis berubah saat user input nilai
      // target.nilai_akhir = calculateFinal(target);
      const finalScore = calculateFinal(target);

      target.nilai_akhir = finalScore;
      target.kkca_description = getKKCA(finalScore);


      copy[index] = target;
      return copy;
    });
  };

  const [updateId, setUpdateID] = useState(null);
  const [scorePicker, setScorePicker] = useState({
    open: false,
    rowIndex: null,
    group: null,
    recapId: null,
    top: 0,
    left: 0,
  });

  const closeScorePicker = () => {
    setScorePicker({
      open: false,
      rowIndex: null,
      group: null,
      recapId: null,
      top: 0,
      left: 0,
    });
    setUpdateID(null);
  };


  // =========================
  // SAVE NILAI
  // =========================
  const originalValueRef = useRef(null);
  const popoverRef = useRef(null);

  const openScorePicker = (event, rowIndex, group, currentValue, isLogLocked = false) => {
    if (isLogLocked) return;

    const rect = event.currentTarget.getBoundingClientRect();
    const pickerWidth = 220;
    const pickerHeight = 56;

    let top = rect.top - pickerHeight - 8;
    let left = rect.left + rect.width / 2 - pickerWidth / 2;

    if (top < 8) top = rect.bottom + 8;
    if (left < 8) left = 8;
    if (left + pickerWidth > window.innerWidth - 8) {
      left = window.innerWidth - pickerWidth - 8;
    }

    const row = rowsRef.current?.[rowIndex];
    const nilaiObj = row?.[group] || {};
    const recapId = nilaiObj?.id && nilaiObj.id !== "default" ? nilaiObj.id : "default";

    originalValueRef.current = currentValue == null ? "" : String(currentValue);

    setUpdateID(recapId);
    setScorePicker({
      open: true,
      rowIndex,
      group,
      recapId,
      top,
      left,
    });
  };



  useEffect(() => {
    if (!scorePicker.open) return;

    // const close = () =>
    //   setScorePicker({ open: false, recapId: null, top: 0, left: 0 });
    const close = () => closeScorePicker();


    const onKeyDown = (e) => {
      if (e.key === "Escape") closeScorePicker();
    };

    const onDocMouseDown = (e) => {
      const target = e.target;

      // klik di popup -> jangan tutup
      if (popoverRef.current && popoverRef.current.contains(target)) return;

      // klik di input score -> biarkan (openScorePicker yang urus)
      if (target.closest?.(".ysb-score-input")) return;

      // klik di luar -> tutup
      closeScorePicker();
    };


    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("mousedown", onDocMouseDown);
    window.addEventListener("scroll", close, true);
    window.addEventListener("resize", close);

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("mousedown", onDocMouseDown);
      window.removeEventListener("scroll", close, true);
      window.removeEventListener("resize", close);
    };
  }, [scorePicker.open]);

  const saveNilai = async (rowIndex, group, overrideCapaian = undefined) => {
    const row = rowsRef.current?.[rowIndex];
    if (!row) return;

    const nilaiObj = row[group];
    if (!nilaiObj) return;

    const effectiveCapaian =
    overrideCapaian !== undefined ? overrideCapaian : nilaiObj?.capaian;

    // id = "default" => create, selain itu => update
    const recapId = nilaiObj?.id && nilaiObj.id !== "default" ? nilaiObj.id : "default";

    // ✅ hanya simpan kalau ada perubahan (biar tidak spam request/toast)
    const currentCapaianStr = normalizeCapaianString(effectiveCapaian);
    const lastSavedStr = normalizeCapaianString(nilaiObj?.__lastSavedCapaian);
    if (currentCapaianStr === lastSavedStr) return;


    // // ✅ validasi range 1 - 4 (kalau tidak valid, batalkan simpan & kembalikan nilai)
    const v = validateCapaianRange(effectiveCapaian);

  
    if (!v.ok) {
      ToastError.fire({
        icon: "error",
        title: "Nilai harus di antara 1 sampai 4",
      });

      // revert ke nilai terakhir yang tersimpan
      setRows((prev) => {
        const copy = [...(prev || [])];
        const target = { ...(copy[rowIndex] || {}) };
        const groupObj = { ...(target[group] || {}) };

        groupObj.capaian = groupObj.__lastSavedCapaian ?? "";
        groupObj.nilai = calculateScore(groupObj.capaian, groupObj.bobot);

        target[group] = groupObj;

        const finalScore = calculateFinal(target);
        target.nilai_akhir = finalScore;
        target.kkca_description = getKKCA(finalScore);

        copy[rowIndex] = target;
        return copy;
      });

      return;
    }

    // Ambil teacher_id dari data_leger (lebih aman)
    const teacherId = data_leger?.ysb_teacher_id || localStorage.getItem("ysb_teacher_id") || "";

    // normalize capaian (sudah tervalidasi 1-4)
    const ysb_sub_element_value = v.num; // bisa null kalau kosong

    const payload = {
      ysb_dimensi_id: data_leger?.ysb_dimensi_id,
      ysb_element_id: data_leger?.ysb_element_id,
      ysb_semester_id: data_leger?.ysb_semester_id,
      ysb_school_id: data_leger?.ysb_school_id,
      ysb_branch_id: data_leger?.ysb_branch_id,
      ysb_teacher_id: teacherId,
      ysb_student_id: data_leger?.ysb_student_id,
      ysb_kelas_id: data_leger?.ysb_kelas_id,
      ysb_categories_penilai_id: nilaiObj?.ysb_categories_penilai_id,
      ysb_sub_element_id: row?.ysb_sub_element_id,
      ysb_sub_element_value,
      user_id,
    };

    const requiredKeys = [
      "ysb_dimensi_id",
      "ysb_element_id",
      "ysb_semester_id",
      "ysb_school_id",
      "ysb_branch_id",
      "ysb_teacher_id",
      "ysb_kelas_id",
      "ysb_student_id",
      "ysb_categories_penilai_id",
      "ysb_sub_element_id",
      "user_id",
    ];
    const missing = requiredKeys.filter((k) => !payload[k]);
    if (missing.length) {
      ToastError.fire({
        icon: "error",
        title: "Tidak bisa menyimpan: data wajib masih kosong",
      });
      console.error("Tidak bisa simpan. Field wajib kosong:", missing, payload);
      return;
    }

    const key = savingKey(rowIndex, group);
    setSavingMap((prev) => ({ ...prev, [key]: true }));

    try {
      const res = await axios.put(
        `https://api.la.sims.alazharsummarecon.sch.id/api/leger-recaps-teacher/${recapId}`,
        payload,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      // ✅ Toast sukses sesuai contoh kamu
      ToastSuccess.fire({
        icon: "success",
        title: res?.data?.message || "Nilai berhasil disimpan",
      });

      // update lastSaved
      setRows((prev) => {
        const copy = [...(prev || [])];
        const target = { ...(copy[rowIndex] || {}) };
        const groupObj = { ...(target[group] || {}) };
        groupObj.__lastSavedCapaian = currentCapaianStr;
        target[group] = groupObj;
        copy[rowIndex] = target;

        // ✅ beri tahu parent (homeLeger) supaya average di table langsung update
        emitSavedToParent(copy);
        return copy;
      });

      // kalau sebelumnya default, coba update id yang baru dibuat supaya next save jadi update
      if (recapId === "default") {
        const newId =
          res?.data?.data?.id ||
          res?.data?.id ||
          res?.data?.data?.ysb_element_recap_id;

        if (newId) {
          setRows((prev) => {
            const copy = [...(prev || [])];
            const target = { ...(copy[rowIndex] || {}) };
            const groupObj = { ...(target[group] || {}) };
            groupObj.id = newId;
            target[group] = groupObj;
            copy[rowIndex] = target;

            // tetap emit agar sub_elements di parent ikut update id terbaru
            emitSavedToParent(copy);
            return copy;
          });
        }
      }
    } catch (err) {
      console.error("Gagal simpan nilai:", err);

      ToastError.fire({
        icon: "error",
        title: err?.response?.data?.message || err?.message || "Tidak berhasil menyimpan",
      });
    } finally {
      setSavingMap((prev) => {
        const next = { ...prev };
        delete next[key];
        return next;
      });
    }
  };

  // Function pilih angka dari popup (langsung save)
  const pickScore = async (value) => {
    const { rowIndex, group } = scorePicker;
    if (rowIndex === null || !group) return;

    const newValue = String(value);
    const oldValue = originalValueRef.current ?? "";

    // update nilai di UI dulu
    setRows((prev) => {
      const copy = [...(prev || [])];
      const target = { ...(copy[rowIndex] || {}) };
      const groupObj = { ...(target[group] || {}) };

      groupObj.capaian = newValue;
      groupObj.nilai = calculateScore(groupObj.capaian, groupObj.bobot);

      target[group] = groupObj;

      const finalScore = calculateFinal(target);
      target.nilai_akhir = finalScore;
      target.kkca_description = getKKCA(finalScore);

      copy[rowIndex] = target;
      return copy;
    });

    // kalau sama, tutup saja
    if (String(newValue) === String(oldValue)) {
      closeScorePicker();
      return;
    }

    // simpan ke API (langsung)
    // await saveNilai(rowIndex, group);
    await saveNilai(rowIndex, group, newValue);


    closeScorePicker();
  };

  const clearScore = async () => {
    const { rowIndex, group } = scorePicker;
    if (rowIndex === null || !group) return;

    const oldValue = originalValueRef.current ?? "";

    // kosongkan nilai di UI dulu
    setRows((prev) => {
      const copy = [...(prev || [])];
      const target = { ...(copy[rowIndex] || {}) };
      const groupObj = { ...(target[group] || {}) };

      groupObj.capaian = "";
      groupObj.nilai = calculateScore(groupObj.capaian, groupObj.bobot);

      target[group] = groupObj;

      const finalScore = calculateFinal(target);
      target.nilai_akhir = finalScore;
      target.kkca_description = getKKCA(finalScore);

      copy[rowIndex] = target;
      return copy;
    });

    // jika sebelumnya sudah kosong, cukup tutup
    if (String(oldValue) === "") {
      closeScorePicker();
      return;
    }

    // await saveNilai(rowIndex, group);
    await saveNilai(rowIndex, group, "");
    closeScorePicker();
  };



  return (
    <>
      <style>{css}</style>
      <Modal show={show} onHide={onHide} fullscreen centered backdrop="static">
      {/* HEADER MODAL */}
      <div className="d-flex align-items-center px-3 pt-3 mb-4">
        <div>
          <h5>{data_leger?.name_student}</h5>
          <p>
            <b>Element:</b> {data_leger?.name_element || "-"}{" "}
            {data_leger?.description ? `- ${data_leger.description}` : ""}
          </p>
        </div>

        <div className="ml-auto x-close">
          <FontAwesomeIcon
            style={{ fontSize: "27px", marginRight: "20px", cursor: "pointer" }}
            icon={faXmark}
            onClick={onHide}
          />
        </div>
      </div>
      <hr className="mt-2 mb-0" />

      {/* BODY MODAL */}
      <Modal.Body style={{ paddingTop: 10 }}>
        {/* WRAPPER UNTUK SCROLL KE SAMPING */}
        <div
          style={{
            width: "100%",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
            border: "1px solid #dee2e6",
          }}
        >
          <table
            className="table table-bordered table-laporan-adab mb-0"
            style={{ minWidth: "1500px", whiteSpace: "nowrap" }}
          >
            <thead style={{ backgroundColor: "#0d6efd", color: "white" }}>
              <tr>
                <th
                  rowSpan={2}
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                    border: "1px solid #fff",
                    color: "#fff",
                  }}
                >
                  Indikator
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Kepala Sekolah
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Guru
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Murid <i>(Peer Assessment)</i>
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Murid <i>(Self Assessment)</i>
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Orang Tua
                </th>
                <th colSpan={3} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                  Karyawan
                </th>
                <th
                  rowSpan={2}
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                    border: "1px solid #fff",
                    color: "#fff",
                  }}
                >
                  Nilai Akhir
                </th>
                <th
                  rowSpan={2}
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                    border: "1px solid #fff",
                    color: "#fff",
                  }}
                >
                  KKCA
                </th>
              </tr>

              <tr>
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`kepsek-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`guru-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`murid-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`murid2-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`otm-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
                {["Capaian", "Bobot", "Nilai"].map((h, i) => (
                  <th key={`karyawan-${i}`} style={{ textAlign: "center", border: "1px solid #fff", color: "#fff" }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {rows.map((row, idx) => {
                const kepsek = getValue(row, "nilai_kepala_sekolah");
                const guru = getValue(row, "nilai_guru");
                const muridPeer = getValue(row, "nilai_murid_peer_assessment");
                const muridSelf = getValue(row, "nilai_murid_self_assessment");
                const otm = getValue(row, "nilai_orang_tua_murid");
                const karyawan = getValue(row, "nilai_karyawan");

                const isSavingMuridPeer = !!savingMap[savingKey(idx, "nilai_murid_peer_assessment")];
                const isSavingMuridSelf = !!savingMap[savingKey(idx, "nilai_murid_self_assessment")];
                const isSaving0tm = !!savingMap[savingKey(idx, "nilai_orang_tua_murid")];

                const finalScore = calculateFinal(row);
                const kkca = getKKCA(finalScore);

                return (
                  <tr key={row.ysb_sub_element_id || idx}>
                    <td
                      style={{
                        border: "1px solid #000",
                        verticalAlign: "top",
                        width: "380px",
                        maxWidth: "380px",
                        minWidth: "380px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        lineHeight: "1.5",
                      }}
                    >
                      {row.ysb_sub_element_name}
                    </td>

                    {/* KEPSEK (READ ONLY) */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{kepsek.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{kepsek.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{kepsek.nilai ?? ""}</td>

                    {/* GURU (READ ONLY) */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{guru.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{guru.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{guru.nilai ?? ""}</td>

                   
                    {/* MURID PEER (INPUT) */}
                    {/* <td style={{ border: "1px solid #000", textAlign: "center" }}>
                      <input
                        className="form-control text-center ysb-score-input"
                        type="text"
                        inputMode="none"
                        readOnly
                        value={muridPeer.capaian ?? ""}
                        onFocus={(e) =>
                          openScorePicker(e, idx, "nilai_murid_peer_assessment", muridPeer.capaian ?? "")
                        }
                        onClick={(e) =>
                          openScorePicker(e, idx, "nilai_murid_peer_assessment", muridPeer.capaian ?? "")
                        }
                        disabled={isSavingMuridPeer}
                        style={{
                          border: "1px solid rgba(183, 213, 253, 1)",
                          backgroundColor: "transparent",
                          opacity: isSavingMuridPeer ? 0.6 : 1,
                          cursor: isSavingMuridPeer ? "not-allowed" : "pointer",
                        }}
                      />

                      
                    </td> */}

                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridPeer.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridPeer.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridPeer.nilai ?? ""}</td>

                    {/* MURID SELF (INPUT) */}
                    {/* <td style={{ border: "1px solid #000", textAlign: "center" }}>
                      <input
                        className="form-control text-center ysb-score-input"
                        type="text"
                        inputMode="none"
                        readOnly
                        value={muridSelf.capaian ?? ""}
                        onFocus={(e) =>
                          openScorePicker(e, idx, "nilai_murid_self_assessment", muridSelf.capaian ?? "")
                        }
                        onClick={(e) =>
                          openScorePicker(e, idx, "nilai_murid_self_assessment", muridSelf.capaian ?? "")
                        }
                        disabled={isSavingMuridSelf}
                        style={{
                          border: "1px solid rgba(183, 213, 253, 1)",
                          backgroundColor: "transparent",
                          opacity: isSavingMuridSelf ? 0.6 : 1,
                          cursor: isSavingMuridSelf ? "not-allowed" : "pointer",
                        }}
                      />

                    </td> */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridSelf.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridSelf.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{muridSelf.nilai ?? ""}</td>

                    {/*  OTM (INPUT) */}
                    {/* <td style={{ border: "1px solid #000", textAlign: "center" }}>
                      <input
                        className="form-control text-center ysb-score-input"
                        type="text"
                        inputMode="none"
                        readOnly
                        value={otm.capaian ?? ""}
                        onFocus={(e) =>
                          openScorePicker(e, idx, "nilai_orang_tua_murid", otm.capaian ?? "")
                        }
                        onClick={(e) =>
                          openScorePicker(e, idx, "nilai_orang_tua_murid", otm.capaian ?? "")
                        }
                        disabled={isSaving0tm}
                        style={{
                          border: "1px solid rgba(183, 213, 253, 1)",
                          backgroundColor: "transparent",
                          opacity: isSaving0tm ? 0.6 : 1,
                          cursor: isSaving0tm ? "not-allowed" : "pointer",
                        }}
                      />

                      
                    </td> */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{otm.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{otm.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{otm.nilai ?? ""}</td>

                    {/* KARYAWAN (READ) */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{karyawan.capaian ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{karyawan.bobot ?? ""}</td>
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>{formatScore(getScore(karyawan))}</td>

                    {/* NILAI AKHIR (realtime) + loading saat simpan */}
                    <td style={{ border: "1px solid #000", textAlign: "center", lineHeight: "2" }}>
                      {isSavingMuridPeer || isSavingMuridSelf || isSaving0tm ? (
                        // <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        <ClipLoader size={16} color="#3f5bea"  />
                      ) : (
                        finalScore
                      )}
                    </td>

                    {/* KKCA (realtime) */}
                    <td style={{ border: "1px solid #000", textAlign: "center", fontWeight: "bold", lineHeight: "2" }}>
                      {row.kkca_description}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-center w-100 ">
          <Button className="btn btn-tutup" style={{ backgroundColor: "#faa200ff", border: "none" }} onClick={onHide}>
            Tutup
          </Button>
        </div>
      </Modal.Footer>

      {scorePicker.open && (
        // <div
        //   className="ysb-score-popover"
          
        //   style={{ top: scorePicker.top, left: scorePicker.left }}
        //   onMouseDown={(e) => e.stopPropagation()}
        // >
          <div
  ref={popoverRef}
  className="ysb-score-popover"
  style={{ top: scorePicker.top, left: scorePicker.left, position: "fixed", zIndex: 2000 }}
  onMouseDown={(e) => e.stopPropagation()}
>
          <div className="ysb-score-popover-grid ysb-score-popover-grid-inline">
            {[1, 2, 3, 4].map((n) => (
              <button
                key={n}
                type="button"
                className="ysb-score-btn"
                onMouseDown={(e) => {
                  e.preventDefault();
                  pickScore(n);
                }}
              >
                {n}
              </button>
            ))}


            <button
              type="button"
              className="ysb-score-btn ysb-score-btn-trash"
              title="Hapus nilai"
              onMouseDown={(e) => {
                e.preventDefault();
                clearScore();
              }}
            >
              <FiTrash2 size={16} color="red" />
            </button>

          </div>
        </div>
      )}
    </Modal>
    </>
    

    
  );
}
